// named colors
export const lightRed = '#fc9272'
export const lightBlue = '#9ecae1'
export const boldRed = '#a50f15'
export const boldBlue = '#08519c'
export const veryDarkGray = '#252525'

// static text
export const title = 'Real Median Single Family Sales Price (2020 $), 2000-2020'
export const placeholderText = 'Search for a county'
export const tooltipHeaderPrefix = 'Median price for:'
export const compareHelpText = '(Choose two counties to compare)'
